import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaPlayCircle, FaBookOpen, FaInfoCircle, FaArrowRight } from 'react-icons/fa';
import './CommunityResources.css';

const CommunityResources = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const cards = [
        {
            key: 'videos',
            tab: 'videos',
            icon: <FaPlayCircle className="play-icon" />,
            bgClass: 'bg-video',
            title: t('community.resources.videos'),
            desc: t('community.resources.videosDesc'),
        },
        {
            key: 'guides',
            tab: 'guides',
            icon: <FaBookOpen className="play-icon" />,
            bgClass: 'bg-guides',
            title: t('community.resources.guides'),
            desc: t('community.resources.guidesDesc'),
        },
        {
            key: 'info',
            tab: 'info',
            icon: <FaInfoCircle className="play-icon" />,
            bgClass: 'bg-info',
            title: t('community.resources.info'),
            desc: t('community.resources.infoDesc'),
        },
    ];

    const handleCardClick = (tab) => {
        navigate(`/resources?tab=${tab}`);
    };

    return (
        <section className="community-resources">
            <div className="resources-header">
                <div className="header-text">
                    <h2 className="resources-title">{t('community.resources.title')}</h2>
                    <p className="resources-subtitle">{t('community.resources.subtitle')}</p>
                </div>
                <div className="educational-tag">
                    {t('community.resources.tag')}
                </div>
            </div>

            <div className="resources-grid">
                {cards.map(card => (
                    <div
                        key={card.key}
                        className="resource-card clickable-card"
                        onClick={() => handleCardClick(card.tab)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => e.key === 'Enter' && handleCardClick(card.tab)}
                    >
                        <div className={`card-image ${card.bgClass}`}>
                            {card.icon}
                        </div>
                        <div className="card-content">
                            <h3>{card.title}</h3>
                            <p>{card.desc}</p>
                            <span className="card-explore-link">
                                Explorar <FaArrowRight />
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default CommunityResources;
